import { http } from './_http';
import { logWebHrError } from '@/core/logger/log-wrapper';

/**
 * @return {Promise<AxiosResponse<any>>}
 */
export default async function getForm({
  tenantId,
  onboardingId,
  documentId,
  formPath,
}) {
  try {
    const { data } = await http.get(
      `/tenants/${tenantId}/onboardings/${onboardingId}/documents/${documentId}/form-templates/${formPath}`
    );

    return data.data;
  } catch (e) {
    logWebHrError({
      message: 'Failed to get single form',
      source: 'get-form',
      metadata: {
        tenantId,
        onboardingId,
        documentId,
        formPath,
      },
      error: e,
    });
    throw e;
  }
}
